import request from "../../../utils/request";

//  进件
export function createOrder(data){
    return request({
        url: '/applet/order/ready',
        method: 'post',
        data
    })
}